import { Controller, useFormContext } from "react-hook-form";
import { SwitchUserFormValues } from "../../types";
import { View } from "react-native";
import { TextField } from "@towersystems/roam-common-native";
import { Colors } from "react-native-ui-lib";
import { useSwitchUserFormAdditionalActions } from "../../hooks";

export interface PasswordFieldsetProps {}

export const PasswordFieldset = ({}: PasswordFieldsetProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SwitchUserFormValues>();

  const maybeContext = useSwitchUserFormAdditionalActions();

  return (
    <View>
      <Controller
        name="password"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <TextField
              placeholder="Password"
              secureTextEntry={true}
              value={value}
              onChangeText={onChange}
              enableErrors
              onSubmitEditing={maybeContext?.onSubmitEditingAll}
              validationMessage={errors.password?.message}
              fieldStyle={{ backgroundColor: Colors.white }}
            />
          );
        }}
      ></Controller>
    </View>
  );
};
